import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import BarChart from "../ui/BarChart";

const MargeNette = () => {
  const [couteTransport, setCouteTransport] = useState(0);
  const [selectedChain, setSelectedChain] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [chains, setChains] = useState([]);
  const [error, setError] = useState(null);
  const [systemConstant, setSystemConstant] = useState({
    Nombre_d_heures_par_jour: "",
    Taux_horaire_SMIG_16_29: "",
    Taux_horaire_17_00: "",
    Taux_horaire_17_50: "",
    Masse_salariale_16_29: "",
    Masse_salariale_17_00: "",
    Masse_salariale_17_50: "",
    Capacité_par_unité_transport: "",
    cotisation_entroprise_trans: "",
    Coût_par_trajet: "",
    Coût_énergie_journalier: "",
    Coût_charges_fixes_journalier: "",
    Base_reference_matiere_fil: 20000,
    Base_reference_matiere_plastique: 15000,
    Coût_fil_unitaire: 20000,
    Coût_plastique_unitaire: 15000,
  });

  const [effectifDirect, setEffectifDirect] = useState(0);
  const [effectifInDirect, setEffectifInDirect] = useState(0);
  const [totalEffectifDirects, setTotalEffectifDirects] = useState(0);
  const [totalChains, setTotalChains] = useState(0);
  const [totalHours, setTotalHours] = useState(0);
  const [workedHoursByDate, setWorkedHoursByDate] = useState({});
  const [effectiveDataByDate, setEffectiveDataByDate] = useState({});
  const [effectiveIndirectDataByDate, setEffectiveIndirectDataByDate] = useState({});
  const [massSalaryDirect, setMassSalaryDirect] = useState(0);
  const [massSalaryInDirect, setMassSalaryInDirect] = useState(0);
  const [totalMassSalary, setTotalMassSalary] = useState(0);
  const [totalExport, setTotalExport] = useState(0);
  const [coûtEnergie, setCoûtEnergie] = useState(0);
  const [coûtChargesFixes, setCoûtChargesFixes] = useState(0);
  const [coûtDeRevient, setCoûtDeRevient] = useState(0);
  const [productionChainValeur, setProductionChainValeur] = useState(0);
  const [margeBruteDepot, setMargeBruteDepot] = useState(0);
  const [margeNetteDepot, setMargeNetteDepot] = useState(0);
  
  // Add missing fil/plastic state variables
  const [filsParChain, setFilsParChain] = useState(0);
  const [filsParChainPre, setFilsParChainPre] = useState(0);
  const [hasSystemConstant, setHasSystemConstant] = useState(false);
  const [models, setModels] = useState([]);
  const [cle, setCle] = useState(0);

  const fetchCle = async (selectedChain) => {
        try {
            const response = await api.get(`/product_plans_cle/${selectedChain}`);
            setCle(response.data.cle);
            console.log("response.data", response.data)
        } catch (error) {
            console.error("Error fetching cle:", error);
        }
    };

    useEffect(() => {
        if (selectedChain) {
        fetchCle(selectedChain);
        }
  }, [selectedChain]);


  
  const [barChartData, setBarChartData] = useState({
    labels: [
      "Production en valeur",
      "Coût de revient",
      "Marge nette",
    ],
    datasets: [
      {
        data: [0, 0, 0, 0],
        backgroundColor: ["rgba(75,192,192,0.2)"],
        borderColor: ["rgba(75,192,192,1)"],
        borderWidth: 1,
      },
    ],
  });

  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "",
        },
      },
      y: {
        title: {
          display: true,
          text: "Value",
        },
      },
    },
  };

  // Add fil/plastic calculations like in MargeNetteTable.js
  const calculateCouteFil = () => {
      if (!totalExport || totalExport <= 0) {
      console.log("No totalExport available, skipping fil calculation");
        return;
      }

    console.log("🔍 === CALCULATION: Fil TOTAL pour le modèle ===");
      console.log("📊 Input Data:");
      console.log("  - totalExport:", totalExport);
      
    const baseReference = Number(systemConstant.Base_reference_matiere_fil) || 20000;
    const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
    const filCost = totalExport * (filUnitCost / baseReference);

    setFilsParChain(filCost);
    setFilsParChainPre(filCost);

    console.log("✅ Using direct calculation from system constants:", {
      totalExport,
      filCost,
      formula: `${totalExport} * (${filUnitCost} / ${baseReference}) = ${filCost}`
    });
    
    console.log("🔍 === END CALCULATION ===");
  };

  const fetchChainData = async (modelId, chainId) => {
    try {
      setError(null);
      const response = await api.get(`/chain_production_data/${modelId}`, {
        params: { chain: chainId },
      });

      console.log("Chain data response:", response.data[chainId].latestSortie);
      setTotalExport(response.data[chainId].latestSortie || 0);

      // Get model data for calculations
      const modelsResponse = await api.get("/models");
      const modelData = modelsResponse.data.find((model) => {
          return model.id == modelId;
        });
  
      if (modelData) {
        const productionChainValeur = (
          modelData.prixMOver *
          (modelData.prixFacture /
            (modelData.prixMOver * modelData.qte_societe)) *
          (response.data[chainId].latestSortie || 0)
        ).toFixed(2);
  
        console.log('productionChainValeur', productionChainValeur);
        console.log('modelData', modelData);
        console.log('response.data.totalSortie', response.data.totalSortie);
        
        setProductionChainValeur(productionChainValeur);
      }
    } catch (error) {
      console.error("Error fetching chain data:", error);
      setError(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    if (selectedModel && totalExport && totalExport > 0) {
      calculateCouteFil();
    }
  }, [selectedModel, totalExport]);

  useEffect(() => {
    const fetchChains = async () => {
      try {
        const response = await api.get("/chains");
        setChains(response.data);
      } catch (error) {
        console.error("Error fetching chains:", error);
      }
    };

    fetchChains();
  } , [])

  const calculateCouteTransport = () => {
    const {
      Nombre_d_heures_par_jour,
      Capacité_par_unité_transport,
      Coût_par_trajet,
      cotisation_entroprise_trans,
    } = systemConstant;

    let totalTransportCost = 0;
    const dailyTransportCosts = {};

    console.log("🔍 === DAY-BY-DAY TRANSPORT COST CALCULATION ===");
    console.log("📊 Effective Direct Data:", effectiveDataByDate);
    console.log("📊 Effective Indirect Data:", effectiveIndirectDataByDate);
    console.log("📊 Worked Hours Data:", workedHoursByDate);

    // Loop through all dates that have worked hours
    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      const directData = effectiveDataByDate[date];
      const indirectData = effectiveIndirectDataByDate[date];

      if (workedHours > 0 && (directData || indirectData)) {
        // Get effective direct for this day
        const effectifDirectDay = directData ? directData.effectifDirects : 0;
        
        // Get effective indirect for this day
        const effectifIndirectDay = indirectData ? indirectData.effectifIndirects : 0;
        
        // Calculate QP_effectif for this day
        const QP_effectif = effectifIndirectDay * cle;

        // Calculate days of production for this day (1 day)
        const Nombre_de_jours_de_production = 1;

        // Calculate refacturation for this day
    const Refacturation_transport_MOD_indirecte = -(
      (cotisation_entroprise_trans *
        Nombre_de_jours_de_production *
        QP_effectif) /
      26
    );

    const Refacturation_transport_MOD_directe = -(
      (cotisation_entroprise_trans *
        Nombre_de_jours_de_production *
            effectifDirectDay) /
      26
    );

        // Calculate number of units used for this day
    const Nombre_unite_utilise =
          (QP_effectif + effectifDirectDay) / Capacité_par_unité_transport;

        // Calculate transport cost for this day
        const dailyTransportCost =
      2 *
        Nombre_unite_utilise *
        Nombre_de_jours_de_production *
        Coût_par_trajet +
      (Refacturation_transport_MOD_directe +
        Refacturation_transport_MOD_indirecte);

        dailyTransportCosts[date] = dailyTransportCost;
        totalTransportCost += dailyTransportCost;

        console.log(`📅 ${date}:`, {
          workedHours,
          effectifDirectDay,
          effectifIndirectDay,
      QP_effectif,
      cle,
      Refacturation_transport_MOD_indirecte,
      Refacturation_transport_MOD_directe,
      Nombre_unite_utilise,
      Nombre_de_jours_de_production,
      Coût_par_trajet,
      cotisation_entroprise_trans,
          dailyTransportCost,
          runningTotal: totalTransportCost
        });
      }
    });

    console.log("🧮 Final Total Transport Cost (Day-by-Day):", totalTransportCost);
    console.log("📊 Daily Transport Costs:", dailyTransportCosts);
    console.log("🔍 === END DAY-BY-DAY TRANSPORT COST CALCULATION ===");

    setCouteTransport(totalTransportCost.toFixed(4));
  };

  const calculateTotalMasseSalariale = () => {
    const {
      Taux_horaire_SMIG_16_29,
      Taux_horaire_17_00,
      Taux_horaire_17_50,
      Masse_salariale_16_29,
      Masse_salariale_17_00,
      Masse_salariale_17_50,
    } = systemConstant;

    console.log("🔍 === MASS SALARY CALCULATION (Using Day-by-Day Total) ===");
    console.log("📊 Input Values:");
    console.log("  - totalHours:", totalHours);
    console.log("  - effectifDirect (Day-by-Day Calculated):", effectifDirect);
    console.log("  - Taux_horaire_SMIG_16_29:", Taux_horaire_SMIG_16_29);
    console.log("  - Masse_salariale_16_29:", Masse_salariale_16_29);

    const congeAnual =
      (totalEffectifDirects * Taux_horaire_SMIG_16_29 * 1.5) / 26;

    const masseSalariale1629 =
      totalEffectifDirects *
      Masse_salariale_16_29 *
      0.01 *
      Taux_horaire_SMIG_16_29;

      console.log("🧮 Calculations:");
      console.log("  - congeAnual:", congeAnual);
      console.log("  - masseSalariale1629:", masseSalariale1629);

    const masseSalariale1700 =
      totalEffectifDirects *
      Masse_salariale_17_00 *
      0.01 *
      Taux_horaire_17_00;

    const masseSalariale1750 =
    totalEffectifDirects *
      Masse_salariale_17_50 *
      0.01 *
      Taux_horaire_17_50;

    const QP_effectif = effectifInDirect;

    const congeAnualIndirect =
      ( QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;

    const masseSalarialeIndirect1629 =
      QP_effectif *
      Masse_salariale_16_29 *
      0.01 *
      Taux_horaire_SMIG_16_29;

    const masseSalarialeIndirect1700 =
      QP_effectif *
      Masse_salariale_17_00 *
      0.01 *
      Taux_horaire_17_00;

    const masseSalarialeIndirect1750 =
      QP_effectif *
      Masse_salariale_17_50 *
      0.01 *
      Taux_horaire_17_50;

    const masseSalarialeDirecte =
      masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;

    const masseSalarialeInDirecte =
      masseSalarialeIndirect1700 +
      masseSalarialeIndirect1629 +
      masseSalarialeIndirect1750 +
      congeAnualIndirect;

    console.log("🧮 Final Mass Salary Results:");
    console.log("  - masseSalarialeDirecte:", masseSalarialeDirecte);
    console.log("  - masseSalarialeInDirecte:", masseSalarialeInDirecte);
    console.log("  - Total Mass Salary:", masseSalarialeDirecte + masseSalarialeInDirecte);
    console.log("🔍 === END MASS SALARY CALCULATION ===");

    setMassSalaryInDirect(masseSalarialeInDirecte.toFixed(4));
    setMassSalaryDirect(masseSalarialeDirecte.toFixed(4));
    setTotalMassSalary(
      (masseSalarialeInDirecte + masseSalarialeDirecte).toFixed(4)
    );
  };

  const calculateCoûtEnergie = () => {
    const { Coût_énergie_journalier, Nombre_d_heures_par_jour } = systemConstant;
    
    let totalEnergyCost = 0;
    const dailyEnergyCosts = {};

    console.log("🔍 === DAY-BY-DAY ENERGY COST CALCULATION ===");
    console.log("📊 Worked Hours Data:", workedHoursByDate);
    console.log("📊 Coût_énergie_journalier:", Coût_énergie_journalier);
    console.log("📊 Nombre_d_heures_par_jour:", Nombre_d_heures_par_jour);

    // Loop through all dates that have worked hours
    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      
      if (workedHours > 0) {
        // Calculate days of production for this day based on worked hours
        const Nombre_de_jours_de_production = workedHours / Nombre_d_heures_par_jour;
        
        // Calculate energy cost for this day
        const dailyEnergyCost = Nombre_de_jours_de_production * Coût_énergie_journalier * cle;
        
        dailyEnergyCosts[date] = dailyEnergyCost;
        totalEnergyCost += dailyEnergyCost;

        console.log(`📅 ${date}:`, {
          workedHours,
      Nombre_de_jours_de_production,
      Coût_énergie_journalier,
          dailyEnergyCost,
          runningTotal: totalEnergyCost
        });
      }
    });

    console.log("🧮 Final Total Energy Cost (Day-by-Day):", totalEnergyCost);
    console.log("📊 Daily Energy Costs:", dailyEnergyCosts);
    console.log("🔍 === END DAY-BY-DAY ENERGY COST CALCULATION ===");
    
    setCoûtEnergie(totalEnergyCost);
  };

  const calculateCoûtChargesFixes = () => {
    const { Coût_charges_fixes_journalier, Nombre_d_heures_par_jour } = systemConstant;
    
    let totalChargesFixesCost = 0;
    const dailyChargesFixesCosts = {};

    console.log("🔍 === DAY-BY-DAY CHARGES FIXES COST CALCULATION ===");
    console.log("📊 Worked Hours Data:", workedHoursByDate);
    console.log("📊 Coût_charges_fixes_journalier:", Coût_charges_fixes_journalier);
    console.log("📊 Nombre_d_heures_par_jour:", Nombre_d_heures_par_jour);

    // Loop through all dates that have worked hours
    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      
      if (workedHours > 0) {
        // Calculate days of production for this day based on worked hours
        const Nombre_de_jours_de_production = workedHours / Nombre_d_heures_par_jour;
        
        // Calculate charges fixes cost for this day
        const dailyChargesFixesCost = Nombre_de_jours_de_production * Coût_charges_fixes_journalier * cle;
        
        dailyChargesFixesCosts[date] = dailyChargesFixesCost;
        totalChargesFixesCost += dailyChargesFixesCost;

        console.log(`📅 ${date}:`, {
          workedHours,
      Nombre_de_jours_de_production,
      Coût_charges_fixes_journalier,
          dailyChargesFixesCost,
          runningTotal: totalChargesFixesCost
        });
      }
    });

    console.log("🧮 Final Total Charges Fixes Cost (Day-by-Day):", totalChargesFixesCost);
    console.log("📊 Daily Charges Fixes Costs:", dailyChargesFixesCosts);
    console.log("🔍 === END DAY-BY-DAY CHARGES FIXES COST CALCULATION ===");
    
    setCoûtChargesFixes(totalChargesFixesCost);
  };

  const calculateCoûtDeRevient = () => {
    // Add fil/plastic costs to the calculation like in MargeNetteTable.js
    const filCost = filsParChain;
    
    const totalCost =
      parseFloat(totalMassSalary) +
      parseFloat(couteTransport) +
      parseFloat(coûtChargesFixes) +
      parseFloat(coûtEnergie) +
      parseFloat(filCost);

    console.log("🔍 === CALCULATION: Coût de revient (MargeNette.js) ===");
    console.log("📊 Input Data:");
    console.log("  - totalMassSalary:", parseFloat(totalMassSalary));
    console.log("  - couteTransport:", parseFloat(couteTransport));
    console.log("  - coûtChargesFixes:", parseFloat(coûtChargesFixes));
    console.log("  - coûtEnergie:", parseFloat(coûtEnergie));
    console.log("  - filCost:", parseFloat(filCost));
    console.log("🧮 Total Cost:", totalCost);
    console.log("🔍 === END CALCULATION ===");

    setCoûtDeRevient(totalCost.toFixed(2));
    return totalCost;
  };

  const calculateMargeBruteDepot = () => {
    const coûtDeRevient = calculateCoûtDeRevient();
    const margeBrute = parseFloat(productionChainValeur) - coûtDeRevient;
    setMargeBruteDepot(margeBrute.toFixed(2));
    return margeBrute;
  };

  const calculateMargeNetteDepot = () => {
    const margeBruteDepot = calculateMargeBruteDepot();
    console.log("Marge brute depot:", margeBruteDepot);
    const margeNette = margeBruteDepot > 0 ? margeBruteDepot - margeBruteDepot * 0.2 : margeBruteDepot;
    console.log("Marge nette depot:", margeNette);
    setMargeNetteDepot(margeNette.toFixed(2));
    return margeNette;
  };

  const fetchWorkedHours = async (modelId) => {
    try {
      const response = await api.get(`/production_real_hours/${modelId}/${selectedChain}`);
      
      setWorkedHoursByDate(response.data.worked_hours_by_date || {});
      
      // Calculate total hours for backward compatibility
      const totalHours = Object.values(response.data.worked_hours_by_date || {}).reduce((sum, hours) => sum + hours, 0);
      setTotalHours(totalHours);
      
      console.log("Worked hours by date:", response.data.worked_hours_by_date);
      console.log("Total worked hours:", totalHours);
    } catch (error) {
      console.error("Error fetching worked hours:", error);
      setError(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const modelsResponse = await api.get("/models");
        setModels(modelsResponse.data);

        const systemResponse = await api.get("/system_constants_latest");
        if (systemResponse.data) {
          const { id, created_at, updated_at, effectif_fix, ...filteredData } =
            systemResponse.data;
          setSystemConstant({
            ...filteredData,
          });
          setHasSystemConstant(true);
        }

        const responseChains = await api.get(`/total_chain`);
        setTotalChains(parseInt(responseChains.data.total_chains));
        
        if(selectedModel && selectedChain) {
          const responseDirect = await api.get(
            `/effective_real_total/${selectedModel}/${selectedChain}`
          );
          
          // Check if we got the detailed data by date or the summary
          if (responseDirect.data && typeof responseDirect.data === 'object') {
            // Store the effective data by date
            setEffectiveDataByDate(responseDirect.data);
            
            // If we have worked hours by date, do day-by-day calculation
            if (Object.keys(workedHoursByDate).length > 0) {
              const dayByDayTotal = calculateDayByDayEffectifDirects(responseDirect.data, workedHoursByDate);
              setEffectifDirect(dayByDayTotal);
              setTotalEffectifDirects(dayByDayTotal);
              console.log("Updated effectifDirect with day-by-day calculation:", dayByDayTotal);
            } else {
              // Fallback to simple sum if no worked hours data yet
              const totalDirects = calculateTotalEffectifDirects(responseDirect.data);
              setEffectifDirect(totalDirects);
              setTotalEffectifDirects(totalDirects);
              console.log("Updated effectifDirect with simple sum:", totalDirects);
            }
          } else if (responseDirect.data && responseDirect.data.total_effectif_direct) {
            // If it's the summary format, use the existing field
          setEffectifDirect(parseInt(responseDirect.data.total_effectif_direct));
            setTotalEffectifDirects(parseInt(responseDirect.data.total_effectif_direct));
          }
          
          // Fetch effective indirect data by day
          try {
            const responseIndirectByDay = await api.get(`/effective_indirect_by_model_chain_day/${selectedModel}/${selectedChain}`);
            
            if (responseIndirectByDay.data && typeof responseIndirectByDay.data === 'object') {
              // Store the effective indirect data by date
              setEffectiveIndirectDataByDate(responseIndirectByDay.data);
              
              // If we have worked hours by date, do day-by-day calculation
              if (Object.keys(workedHoursByDate).length > 0) {
                const dayByDayIndirectTotal = calculateDayByDayEffectifIndirects(responseIndirectByDay.data, workedHoursByDate);
                setEffectifInDirect(dayByDayIndirectTotal);
                console.log("Updated effectifInDirect with day-by-day calculation:", dayByDayIndirectTotal);
            } else {
                // Fallback to simple sum if no worked hours data yet
                const totalIndirects = Object.values(responseIndirectByDay.data).reduce((sum, dayData) => {
                  return sum + (dayData.effectifIndirects || 0);
                }, 0);
                setEffectifInDirect(totalIndirects);
                console.log("Updated effectifInDirect with simple sum:", totalIndirects);
              }
            }
          } catch (error) {
            console.error("Error fetching effective indirect data by day:", error);
            // Fallback to general effective indirect
            try {
            const responseIndirect = await api.get(`/effective_indirect`);
            setEffectifInDirect(parseInt(responseIndirect.data.total_effectif_indirect));
              console.log("Using general effective indirect fallback:", responseIndirect.data.total_effectif_indirect);
            } catch (fallbackError) {
              console.error("Fallback effective indirect also failed:", fallbackError);
              setEffectifInDirect(0);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedModel]);

  useEffect(() => {
    if (
      totalHours > 0 &&
      effectifDirect > 0 &&
      effectifInDirect > 0 &&
      totalChains > 0 &&
      systemConstant.Nombre_d_heures_par_jour &&
      hasSystemConstant
    ) {
      console.log("Calculations triggered with data:", {
        totalHours,
        effectifDirect,
        effectifInDirect,
        totalChains,
        hasSystemConstant,
        filsParChain
      });
      
      calculateTotalMasseSalariale();
    } else {
      console.log("Calculations not triggered - missing data:", {
        totalHours: totalHours > 0,
        effectifDirect: effectifDirect > 0,
        effectifInDirect: effectifInDirect > 0,
        totalChains: totalChains > 0,
        hasSystemConstant,
        filsParChain: filsParChain > 0
      });
    }
  }, [
    totalHours,
    effectifDirect,
    effectifInDirect,
    totalChains,
    totalExport,
    systemConstant,
    hasSystemConstant,
    filsParChain
  ]);

  useEffect(() => {
    if (selectedModel) {
      fetchWorkedHours(selectedModel);
    }
  }, [selectedModel]);

  // Fetch effective data when both model and chain are selected
  useEffect(() => {
    const fetchEffectiveData = async () => {
      if (selectedModel && selectedChain) {
        try {
          const responseDirect = await api.get(
            `/effective_real_total/${selectedModel}/${selectedChain}`
          );
          
          // Check if we got the detailed data by date or the summary
          if (responseDirect.data && typeof responseDirect.data === 'object') {
            // Store the effective data by date
            setEffectiveDataByDate(responseDirect.data);
            
            // If we have worked hours by date, do day-by-day calculation
            if (Object.keys(workedHoursByDate).length > 0) {
              const dayByDayTotal = calculateDayByDayEffectifDirects(responseDirect.data, workedHoursByDate);
              setEffectifDirect(dayByDayTotal);
              setTotalEffectifDirects(dayByDayTotal);
              console.log("Updated effectifDirect with day-by-day calculation:", dayByDayTotal);
            } else {
              // Fallback to simple sum if no worked hours data yet
              const totalDirects = calculateTotalEffectifDirects(responseDirect.data);
              setEffectifDirect(totalDirects);
              setTotalEffectifDirects(totalDirects);
              console.log("Updated effectifDirect with simple sum:", totalDirects);
            }
          } else if (responseDirect.data && responseDirect.data.total_effectif_direct) {
            // If it's the summary format, use the existing field
            setEffectifDirect(parseInt(responseDirect.data.total_effectif_direct));
            setTotalEffectifDirects(parseInt(responseDirect.data.total_effectif_direct));
          }
        } catch (error) {
          console.error("Error fetching effective data:", error);
        }
      }
    };

    fetchEffectiveData();
  }, [selectedModel, selectedChain]);

  // Trigger day-by-day calculation when both effective data and worked hours are available
  useEffect(() => {
    if (Object.keys(effectiveDataByDate).length > 0 && Object.keys(workedHoursByDate).length > 0) {
      const dayByDayTotal = calculateDayByDayEffectifDirects(effectiveDataByDate, workedHoursByDate);
      setEffectifDirect(dayByDayTotal);
      setTotalEffectifDirects(dayByDayTotal);
      console.log("🔄 Recalculated effectifDirect with day-by-day calculation:", dayByDayTotal);
    }
  }, [effectiveDataByDate, workedHoursByDate]);

  // Trigger day-by-day calculation for effective indirect when both datasets are available
  useEffect(() => {
    if (Object.keys(effectiveIndirectDataByDate).length > 0 && Object.keys(workedHoursByDate).length > 0) {
      const dayByDayIndirectTotal = calculateDayByDayEffectifIndirects(effectiveIndirectDataByDate, workedHoursByDate);
      setEffectifInDirect(dayByDayIndirectTotal);
      console.log("🔄 Recalculated effectifInDirect with day-by-day calculation:", dayByDayIndirectTotal);
    }
  }, [effectiveIndirectDataByDate, workedHoursByDate]);

  // Trigger day-by-day transport cost calculation when all day-by-day data is available
  useEffect(() => {
    if (Object.keys(effectiveDataByDate).length > 0 && 
        Object.keys(effectiveIndirectDataByDate).length > 0 && 
        Object.keys(workedHoursByDate).length > 0) {
      calculateCouteTransport();
      console.log("🔄 Recalculated transport cost with day-by-day calculation");
    }
  }, [effectiveDataByDate, effectiveIndirectDataByDate, workedHoursByDate]);

  // Trigger day-by-day energy cost calculation when worked hours data is available
  useEffect(() => {
    if (Object.keys(workedHoursByDate).length > 0) {
      calculateCoûtEnergie();
      console.log("🔄 Recalculated energy cost with day-by-day calculation");
    }
  }, [workedHoursByDate]);

  // Trigger day-by-day charges fixes cost calculation when worked hours data is available
  useEffect(() => {
    if (Object.keys(workedHoursByDate).length > 0) {
      calculateCoûtChargesFixes();
      console.log("🔄 Recalculated charges fixes cost with day-by-day calculation");
    }
  }, [workedHoursByDate]);

  useEffect(() => {
    const coûtDeRevient = calculateCoûtDeRevient();
    const margeBruteDepot = calculateMargeBruteDepot();
    const margeNetteDepot = calculateMargeNetteDepot();

    const dataValues = [
      parseInt(productionChainValeur),
      coûtDeRevient,
      margeNetteDepot,
    ];

    const backgroundColors = dataValues.map((value) =>
      value < 0 ? "rgba(255,0,0,0.2)" : "rgba(75,192,192,0.2)"
    );

    const borderColors = dataValues.map((value) =>
      value < 0 ? "rgba(255,0,0,1)" : "rgba(75,192,192,1)"
    );

    setBarChartData({
      labels: [
        "Production en valeur",
        "Coût de revient",
        "Marge nette",
      ],
      datasets: [
        {
          data: dataValues,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
        },
      ],
    });
  }, [
    totalMassSalary,
    couteTransport,
    coûtChargesFixes,
    coûtEnergie,
    productionChainValeur,
  ]);

  const calculateTotalEffectifDirects = (effectiveData) => {
    let total = 0;
    
    // Loop through all dates in the response
    Object.keys(effectiveData).forEach(date => {
      const dayData = effectiveData[date];
      if (dayData && dayData.effectifDirects) {
        total += dayData.effectifDirects;
      }
    });
    
    console.log("Total Effectif Directs calculated:", total);
    return total;
  };

  const calculateDayByDayEffectifDirects = (effectiveData, workedHoursData) => {
    let total = 0;
    
    console.log("🔍 === DAY-BY-DAY CALCULATION (DIRECT) ===");
    console.log("📊 Effective Data:", effectiveData);
    console.log("📊 Worked Hours Data:", workedHoursData);
    
    // Loop through all dates in the effective data
    Object.keys(effectiveData).forEach(date => {
      const dayData = effectiveData[date];
      const workedHours = workedHoursData[date] || 0;
      
      if (dayData && dayData.effectifDirects) {
        const dayCalculation = dayData.effectifDirects * workedHours;
        total += dayCalculation;
        
        console.log(`📅 ${date}:`, {
          effectifDirects: dayData.effectifDirects,
          workedHours: workedHours,
          calculation: `${dayData.effectifDirects} × ${workedHours} = ${dayCalculation}`,
          runningTotal: total
        });
      }
    });
    
    console.log("🧮 Final Total (Day-by-Day Direct):", total);
    console.log("🔍 === END DAY-BY-DAY CALCULATION (DIRECT) ===");
    
    return total;
  };

  const calculateDayByDayEffectifIndirects = (effectiveIndirectData, workedHoursData) => {
    let total = 0;
    
    console.log("🔍 === DAY-BY-DAY CALCULATION (INDIRECT) ===");
    console.log("📊 Effective Indirect Data:", effectiveIndirectData);
    console.log("📊 Worked Hours Data:", workedHoursData);
    
    // Loop through all dates in the effective indirect data
    Object.keys(effectiveIndirectData).forEach(date => {
      const dayData = effectiveIndirectData[date] ;
      const workedHours = workedHoursData[date] || 0;
      
      if (dayData && dayData.effectifIndirects) {
        let dayCalculation = dayData.effectifIndirects * cle ;
        dayCalculation = dayCalculation * workedHours;
        console.log("dayCalculation", dayCalculation);
        console.log("dayData.effectifIndirects", dayData.effectifIndirects);
        console.log("cle", cle);
        console.log("workedHours", workedHours);
        total += dayCalculation;
        
        console.log(`📅 ${date}:`, {
          effectifIndirects: dayData.effectifIndirects,
          workedHours: workedHours,
          calculation: `${dayData.effectifIndirects} × ${workedHours} = ${dayCalculation}`,
          runningTotal: total
        });
      }
    });
    
    console.log("🧮 Final Total (Day-by-Day Indirect):", total);
    console.log("🔍 === END DAY-BY-DAY CALCULATION (INDIRECT) ===");
    
    return total;
  };

  const fetchModelByChain = async (chainId) => {
    try {
        const response = await api.get(`/getmodelsByChain/${chainId}`);
        // Get the first model (assuming one chain works on one model at a time)
        console.log(response.data);
        const modelId = response.data.id;
        setSelectedModel(modelId);
        console.log("Model found for chain:", modelId);
        return modelId;
    } catch (error) {
      console.error("Error fetching model by chain:", error);
      setSelectedModel("");
      return null;
    }
  };

  const handleChainChange = async (e) => {
    const chainId = e.target.value;
    setSelectedChain(chainId);
    
    if (chainId) {
      const modelId = await fetchModelByChain(chainId);
      if (modelId) {
        fetchChainData(modelId, chainId);
      }
    } else {
      setSelectedModel("");
      setTotalExport(0);
      setProductionChainValeur(0);
    }
  };


  return (
    <div className="ml-7">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">La Marge Nette Réelle Chaîne</h2>
        <div className="flex items-center justify-between">
            <div className="ml-7 mb-4 pr-6">
              <select
                className="block w-full mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
                value={selectedChain}
                onChange={handleChainChange}
              >
                <option value="">Choisir une chaîne</option>
                {chains.map((chain) => (
                  <option key={chain.id} value={chain.id}>
                    {chain.name}
                  </option>
                ))}
              </select>
            </div>
        </div>
      </div>
      <div className="w-full mr-5">
        {error ? (
          <div className="text-red-500 ml-7">{error}</div>
        ) : (
          <>
            
            <BarChart data={barChartData} options={barChartOptions} />
          </>
        )}
      </div>
    </div>
  );
};

export default MargeNette;
